module.exports = __webpack_public_path__ + "static/img/thumb-practices-to-protect-water-quality.c3894ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-practices-to-protect-water-quality.png
// module id = 94
// module chunks = 0